import script from "./detailHome.vue?vue&type=script&setup=true&lang=js"
export * from "./detailHome.vue?vue&type=script&setup=true&lang=js"

import "./detailHome.vue?vue&type=style&index=0&id=c26eb626&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c26eb626"]])

export default __exports__